<template>
  <div class="publishLazad">
      <div class="center">
          <div class="desctext">{{$t('other.a285')}}/SHOPEE</div>
          <div class="hgfb">
            <span>{{$t('other.a288')}}：</span>
            <el-select size="mini" @change="getCategory()" v-model="shopId" :placeholder="$t('other.a50')">
                <el-option v-for="item in shopeeshops" :key="item.shopId" :label="item.shopName" :value="item.shopId"></el-option>
            </el-select>
            <span class="tips">{{$t('other.a2881')}}</span>
          </div>
          <div>
              <span>{{$t('other.a2882')}}:</span>
          </div>
          <div class="categoryWrapper">
              <div >
                  
                  <el-scrollbar class="boxwrapper"> 
                  <div class="ingk" @click="addItem(firstItem,1)" v-for="(firstItem,index) in categorylist" :key="index">
                      <span class="name">{{firstItem.categoryName}}</span>
                      <span class="bkng"></span>
                  </div>
                  </el-scrollbar>
              </div>
              <div >
                  <el-scrollbar class="boxwrapper">
                  <div class="ingk" @click="addItem(firstItem,2)" v-for="(firstItem,index) in categorylistTwo" :key="index">
                      <span class="name">{{firstItem.categoryName}}</span>
                      <span class="bkng"  v-show="firstItem.childrens"></span>
                  </div>
                  </el-scrollbar>
              </div>
              <div >
                  <el-scrollbar class="boxwrapper">
                  <div class="ingk"  @click="addItem(firstItem,3)" v-for="(firstItem,index) in categorylistThree" :key="index">
                      <span class="name">{{firstItem.categoryName}}</span>
                      <span class="bkng" v-show="firstItem.childrens"></span>
                  </div>
                  </el-scrollbar>
              </div>
              <div >
                  <el-scrollbar class="boxwrapper">
                  <div class="ingk"  @click="addItem(firstItem,4)" v-for="(firstItem,index) in categorylistfour" :key="index">
                      <span class="name">{{firstItem.categoryName}}</span>
                      <span class="bkng" v-show="firstItem.childrens"></span>
                  </div>
                  </el-scrollbar>
              </div>
              <div >
                  <el-scrollbar class="boxwrapper">
                  <div class="ingk"  @click="addItem(firstItem,5)" v-for="(firstItem,index) in categorylistfive" :key="index">
                      <span class="name">{{firstItem.categoryName}}</span>
                      <span class="bkng" v-show="firstItem.childrens"></span>
                  </div>
                  </el-scrollbar>
              </div>
          </div>

          <div class="categoryDesc">
              <span class="categoryname">{{$t('other.a2883')}}：</span>
              <span class="categoryname" v-for="(item,index) in categoryname " :key="index">{{item}} 
                  <span v-show="item">/</span>
              </span>
              
          </div>

          <div class="footer">
              <el-button type="primary" @click="publish()">{{$t('other.a2886')}}</el-button>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../../api/api' 
export default {
data(){
return{
    shopeeshops:[],
    userId:null,
    shopId:null,
    categorylist:[],
    shopName:null,
    categorylistTwo:[],
    categorylistThree:[],
    categorylistfour:[],
    categorylistfive:[],
    categoryname:[],
    categoryId:[],
    categoryIdBound:null,//绑定的模版类目Id
    categoryIdList:[]
}
},
created(){
    let shops=JSON.parse(localStorage.getItem('userInfo'))
    this.userId=shops ? shops.userId : null
    this.shopeeshops =shops ? shops.shopeeShops : []
    this.getModelData()
},
methods:{

    getModelData(){
        api
        .getProductByproductId({
            productId:this.$route.query.id
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('模版',res.data)
        this.categoryIdBound=res.data.categoryId
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    publish(){
        if(!this.categoryId[0]){
            this.$message.warning(this.$t('other.a2885'))
            return
        }
        let shopeeshops=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
        let shopTarget=shopeeshops.find(item => item.shopId == this.shopId)
        let params={
            shopId:this.shopId,
            shopName:shopTarget.shopName,
            categoryname:this.categoryname,
            categoryId:this.categoryId,
            country:shopTarget.country
        }

        localStorage.setItem('addLazada',JSON.stringify(params))
        
        
        this.$router.push({
            path:'/addGoods',
            query:{
                productId:this.$route.query.id,
                groupId:this.$route.query.groupId,
                type:'shopee'
                
            }
        })
    },
    addItem(item,num){
        console.log(item,num)
        if(num == 1){
            this.categorylistTwo=item.childrens
            this.categorylistThree=[]
            this.categorylistfour=[]
            this.$set(this.categoryname,num-1,item.categoryName)
            this.$set(this.categoryId,num-1,item.categoryId)
        }
        if(num == 2){
            this.categorylistThree=item.childrens
            this.$set(this.categoryname,num-1,item.categoryName)
            this.$set(this.categoryId,num-1,item.categoryId)
        }
        if(num == 3){
            this.categorylistfour=item.childrens
            this.$set(this.categoryname,num-1,item.categoryName)
            this.$set(this.categoryId,num-1,item.categoryId)
        }

        if(num == 4){
            this.categorylistfive=item.childrens
            this.$set(this.categoryname,num-1,item.categoryName)
            this.$set(this.categoryId,num-1,item.categoryId)
        }

        if(num == 5){
            this.$set(this.categoryname,num-1,item.categoryName)
            this.$set(this.categoryId,num-1,item.categoryId)
        }

        this.categoryname.forEach((p,index) => {
            if(index > num-1){
                this.$set(this.categoryname,index,null)
                this.$set(this.categoryId,index,null)
            }
        })

        console.log('categoryname',this.categoryname)
        console.log('categoryId',this.categoryId)
    },

    

    getCategory(){
        let shopsInfo=this.shopeeshops.find(item => item.shopId == this.shopId)
        api
        .getCategoryByCountry({
            country:shopsInfo.country,
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.categorylist=res.data

        let id=this.categoryIdBound
        let list=[]
        this.categoryIdList=[]

        this.categorylist.forEach(p => {
            p.childrens.forEach(k => {
                if(k.categoryId === id){
                    list.push(p.categoryName)
                    list.push(k.categoryName)
                    this.categoryIdList.push(p.categoryId)
                    this.categoryIdList.push(k.categoryId)
                }else{
                    if(k.childrens !== null){
                            k.childrens.forEach(i => {
                        if(i.categoryId === id){
                                list.push(p.categoryName)
                                list.push(k.categoryName)
                                list.push(i.categoryName)
                                this.categoryIdList.push(p.categoryId)
                                this.categoryIdList.push(k.categoryId)
                                this.categoryIdList.push(i.categoryId)
                        }
                    })
                    }
                    
                }
            })
        })
        
        console.log('list',list)
        console.log('categoryIdList',this.categoryIdList);
        console.log('categoryIdBound',this.categoryIdBound);
        this.categoryname=list
        this.categoryId=this.categoryIdList
        }else{
        this.$message.warning(res.msg)
        }
        })

        
    },

}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.publishLazad{
    margin-top: $top_header_height;
    position: relative;

    .center{
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 1248px;
        // background-color: #eee;
        height: calc(100vh - 50px);

        .categoryDesc{
            background-color: #f7f8fa;
            margin-top: 20px;
            padding: 10px 0;
        }

        .categoryname{
            margin:0  15px;
        }


        .desctext{
            font-size: 20px;
            color: #757575;
            padding: 10px 0;
        }

        .categoryWrapper{
            display: flex;
            margin-top: 15px;
            width:1258px;
            overflow: hidden;
            overflow-x: scroll;

        }

        .footer{
            position: fixed;
            text-align: center;
            left: 0;
            right: 0;
            bottom: 0;
            padding:  15px 0;
            height: 40px;
            background-color: #eee;
        }

        .hgfb{
            padding: 20px 0;
            
        }

        .tips{
            color: red;
            margin-left: 20px;
        }

        .ingk{
            padding: 5px 0;
            cursor: pointer;
        }

        .ingk:hover{
            background-color: #edf7ff;
        }

        .bkng{
            float: right;
            width: 0;
            height: 0;
            border-top: 5px solid transparent;
            border-left: 5px solid #dadada;
            border-bottom: 5px solid transparent;
            position: relative;
            top: 6px;
            right: 15px;
        }

        .boxwrapper{
            width: 312px;
            height: 356px;
            overflow: hidden;
            border: 1px solid #dbdbdb;
        }

        .name{
            font-size: 12px;
            padding-left: 15px;
        }
        
    }

    /deep/ .el-scrollbar__wrap{
        overflow-x: hidden;
    }
}

</style>